// Fiscal year N runs Oct 1 of (N - 1) through Sep 30 of N.
// Capture list:
//   Sep 25 - Sep 30: current + upcoming, default current
//   Oct 1 - Dec 31:  previous + current, default current
//   Jan 1 - Sep 24:  current only
// Archive list: 2017 through the newest year in the capture list.
const FIRST_ARCHIVE_YEAR = 2017;
const PREVIEW_DAY = 25; // Sep 25 starts showing the upcoming fiscal year

const range = (start, end) => {
  const years = [];
  for (let year = start; year <= end; year++) {
    years.push(String(year));
  }
  return years;
};

export const getCurrentFiscalYear = (date = new Date()) => {
  return String(date.getMonth() >= 9 ? date.getFullYear() + 1 : date.getFullYear());
};

export const getFiscalYears = (date = new Date()) => {
  const month = date.getMonth();
  const current = Number(getCurrentFiscalYear(date));

  let capture = [String(current)];
  if (month === 8 && date.getDate() >= PREVIEW_DAY) {
    capture = range(current, current + 1);
  } else if (month >= 9) {
    capture = range(current - 1, current);
  }

  return {
    capture,
    archive: range(FIRST_ARCHIVE_YEAR, Number(capture[capture.length - 1]))
  };
};

export const currentFiscalYear = getCurrentFiscalYear();
export const fiscalYears = getFiscalYears();
